import { Component, Input, OnInit, SimpleChanges, OnChanges, AfterViewInit } from '@angular/core';
import { generateDataChartForIncomeProtection, generateRangeYears } from '@app/features/my-financial/my-financial';

@Component({
  selector: 'app-area-chart',
  templateUrl: './area-chart.component.html'
})
export class AreaChartComponent implements OnInit, AfterViewInit {
  @Input() data: any;

  _data: any;
  categories = [];
  isMobile: boolean;
  valueAxisLabels: any;

  ngOnInit() {
    this.categories = generateRangeYears(this.data.userAge, 100);
    this._data = generateDataChartForIncomeProtection(this.data.form.value, this.data.userAge);
    this.isMobile = /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase());
    this.valueAxisLabels = {
      padding: 3,
      font: this.isMobile ? 'normal 10px Arial, sans-serif' : 'normal 14px Arial, sans-serif',
      color: '#656565'
    };
  }

  ngAfterViewInit() {
    this.data.form.valueChanges.subscribe(formValue => {
      this._data = generateDataChartForIncomeProtection(formValue, this.data.userAge);
    });
  }

  onRender(sender) {
    // TODO: fix bug the chart could not be in 100% width.
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/common/area-chart/area-chart.component.ts